/* rs-pdp-confidence — wiring for the "Free swatch" CTA on the PDP
   Sleep-confidence trust band.

   The CTA now OPENS the shared #rs-swatch-modal (rendered once in the
   footer) and sets contact[Source] before opening. It no longer adds to
   the cart.

   DORMANT CART PATH: window.rsAddSwatch (assets/rs-cart-add.js) and the
   cartUpdate reset subscriber are deliberately retained as an unreached
   fallback — do NOT remove. The .rs-pdp-conf__status span is now
   unreachable (dormant), kept alongside.

   Loaded via <script src="..." defer> at the top of the section; wiring
   is gated on DOMContentLoaded for DOM presence. */

(function () {
  function init() {
    var root = document.querySelector('.rs-pdp-conf');
    if (!root) return;
    var btn = root.querySelector('[data-rs-swatch-add]');
    if (!btn || btn.dataset.rsSwatchBound) return;
    btn.dataset.rsSwatchBound = '1';

    btn.addEventListener('click', function () {
      var src = document.querySelector('#rs-swatch-modal [name="contact[Source]"]');
      if (src) src.value = 'pdp-confidence';
      if (window.rsModal && typeof window.rsModal.open === 'function') {
        window.rsModal.open('rs-swatch-modal');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
